import { useViewerCanAccessNetworkLevelInsights, useViewerCanAccessNetworkQuestions } from '../featureAccessSettings';

export const useIsQnAOrgEntryPointVisible = (): boolean => {
  const viewerCanAccessNetworkLevelInsights = useViewerCanAccessNetworkLevelInsights();
  const viewerCanAccessNetworkQuestions = useViewerCanAccessNetworkQuestions();

  return viewerCanAccessNetworkLevelInsights && viewerCanAccessNetworkQuestions;
};
